import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.5 13.75H10m2.5 5H10m10-10H10m15 3.75v-4c0-2.1 0-3.15-.409-3.952a3.75 3.75 0 0 0-1.639-1.64C22.15 2.5 21.1 2.5 19 2.5h-8c-2.1 0-3.15 0-3.952.409a3.75 3.75 0 0 0-1.64 1.639C5 5.35 5 6.4 5 8.5v13c0 2.1 0 3.15.409 3.953a3.75 3.75 0 0 0 1.639 1.638C7.85 27.5 8.9 27.5 11 27.5h4.625m6.875-1.25s3.75-1.787 3.75-4.468v-3.128l-2.735-.977a3.014 3.014 0 0 0-2.032 0l-2.733.977v3.128c0 2.68 3.75 4.468 3.75 4.468z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }